//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { EntityErrorsModel } from './EntityErrorsModel';
  import { EntityWarningModel } from './EntityWarningModel';
  import { JobStepModel } from './JobStepModel';
  
  export class JobModel extends ModelBase {
      static readonly $typeName = 'JobModel';
      public createdTimestamp: Date;
      public entityErrors: EntityErrorsModel[];
      public entityWarnings: EntityWarningModel[];
      public errorCount: number;
      public errorEntityCount: number;
      public warningCount: number;
      public warningEntityCount: number;
      public key: string;
      public name: string;
      public status: string;
      public steps: JobStepModel[];
      public submittingEntityKey: string;
      public submittingEntityName: string;
      public successfulCount: number;
      public userName: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/JobModel.ts